/** переключатель активного класса для навигации * */
export default function scrollToItem() {
	const sections = Array.from(document.querySelectorAll('[data-scroll-tab="tab"]')).map((item) => ({ id: item.id, offset: item.offsetTop }));

	window.addEventListener("scroll", () => {
		const marginScroll = Array.from(document.querySelectorAll(".js-margin-scroll")).map((item) => item.offsetHeight).reduce((prev, current) => prev + current) || 0;
		const marginTrigger = 20; // дополнительный отступ перед заголовком
		const trigger = window.scrollY + marginTrigger + marginScroll;

		sections.forEach((section) => {
			if (section.offset - 10 <= trigger) {
				document.querySelector(".active").classList.remove("active");
				document.querySelector(`a[href*=${section.id}]`).classList.add("active");
			}
		});
	});
}
